import { PhoneOverride } from '@weave/schema-gen-ts/dist/schemas/phone/override/v2/override_service.pb';
import { Trans, useTranslation } from '@frontend/i18n';
import { BannerNotification, TextLink } from '@frontend/design-system';

export interface OverridePhoneTreeUsageBannerProps {
  overrides?: PhoneOverride[];
  onClickOverrideLink?: () => void;
  trackingIdPrefix?: string;
}

export const OverridePhoneTreeUsageBanner = ({
  overrides,
  onClickOverrideLink,
  trackingIdPrefix,
}: OverridePhoneTreeUsageBannerProps) => {
  const { t } = useTranslation('phone');
  const count = overrides?.length ?? 0;

  if (count === 0) {
    return null;
  }

  return (
    <BannerNotification status='info' fullWidth>
      <Trans t={t} count={count}>
        This Phone Tree is being used in{' '}
        <TextLink
          onClick={onClickOverrideLink}
          trackingId={`${trackingIdPrefix}phone-tree-usage-banner-view-overrides-link`}
        >
          {'{{count}} Override'}
        </TextLink>
        . Note that any changes you make here will impact your override.
      </Trans>
    </BannerNotification>
  );
};
